<div class="notifications">
  <div class="notifications-image" #bell>
    <bp-icon
      [style.color]="'var(--color-neutral-75)'"
      (click)="openModal()"
      cdkOverlayOrigin
      [icon]="'alert'"
      size="24"
    theme="regular"></bp-icon>
  </div>
  @if (countModel$ | async; as countModel) {
    @if (countModel?.count > 0) {
      <div class="notifications-counter">
        @if (countModel?.count >= maxMessageCount) {
          {{ maxMessageCount }}+
        } @else {
          {{ countModel?.count }}
        }
      </div>
    }
  }
</div>
